module.exports = __webpack_public_path__ + "img/mercedes-eqc-5-bottom.dc08264a.jpg";